"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/styles");
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _MapUtils = require("./MapUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable react/jsx-props-no-spreading */
const styles = theme => {
  return {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200
    }
  };
};
const propTypes = {
  /** styles */
  componentForm: _propTypes.default.object,
  address: _propTypes.default.object,
  fields: _propTypes.default.arrayOf(_propTypes.default.string),
  google: _propTypes.default.object,
  onPlaceChange: _propTypes.default.func,
  required: _propTypes.default.bool,
  inputProps: _propTypes.default.object,
  className: _propTypes.default.string,
  variant: _propTypes.default.string,
  multiline: _propTypes.default.bool,
  isAddressValid: _propTypes.default.func,
  validateEmptyAddress: _propTypes.default.bool,
  emptyAddressMsg: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
const defaultProps = {
  address: {},
  fields: ['address_components', 'utc_offset_minutes', 'geometry', 'international_phone_number', 'name', 'formatted_address'],
  google: window.google,
  /**
   * following is required as parsed place.
    {
      "lat": 37.4063062,
      "lng": -121.97649330000002,
      "name": "5201 Great America Pkwy",
      "address": {
        "street_number": "5201",
        "route": "Great America Parkway",
        "locality": "Santa Clara",
        "administrative_area_level_1": "CA",
        "country": "United States",
        "postal_code": "95054"
      }
    }
   */
  onPlaceChange: place => console.log(JSON.stringify(place)),
  componentForm: {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
  },
  required: false,
  inputProps: {},
  className: null,
  variant: 'filled',
  multiline: false,
  isAddressValid: () => {
    return {
      valid: true
    };
  },
  validateEmptyAddress: true,
  emptyAddressMsg: 'Invalid address. Please select address from given options',
  disabled: false
};
const textRef = _react.default.createRef();
let autocomplete = null;
const SearchPlaces = props => {
  const {
    address,
    required,
    inputProps,
    className,
    variant,
    multiline,
    isAddressValid,
    validateEmptyAddress,
    emptyAddressMsg,
    disabled,
    ...rest
  } = props;
  const [text, setText] = (0, _react.useState)('');
  const [validation, setValidation] = (0, _react.useState)({
    valid: true
  });
  const handlePlaceChanged = () => {
    const place = autocomplete.getPlace();
    const {
      componentForm,
      onPlaceChange
    } = props;
    if (place) {
      onPlaceChange((0, _MapUtils.parseGooglePlace)(place), componentForm);
    }
  };
  const initAutocomplete = () => {
    const {
      google,
      fields
    } = props;
    autocomplete = new google.maps.places.Autocomplete(textRef.current);
    autocomplete.setFields(fields);
    autocomplete.addListener('place_changed', handlePlaceChanged);
  };
  (0, _react.useEffect)(() => {
    initAutocomplete();
    return () => {
      google.maps.event.clearInstanceListeners(autocomplete);
      autocomplete = null;
    };
  }, []);
  const validate = () => {
    if (!validateEmptyAddress || text.length > 0 && Object.keys(address).length > 0) {
      setValidation(isAddressValid());
    } else if (validateEmptyAddress && address && Object.keys(address).length === 0 && text.length > 0) {
      setValidation({
        valid: false,
        message: emptyAddressMsg
      });
    } else if (text.length === 0) {
      setValidation(isAddressValid());
    }
  };
  (0, _react.useEffect)(() => {
    if (address) {
      textRef.current.value = (0, _MapUtils.getAddressString)(address);
      setText(textRef.current.value);
    }
  }, [address]);
  (0, _react.useEffect)(() => {
    validate();
    // user cleared thhe address.
    if (text.length === 0) {
      const {
        onPlaceChange
      } = props;
      onPlaceChange();
    }
  }, [text]);
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: [styles.container, className].join(' ')
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    disabled: disabled,
    id: "search_places",
    label: "Find my address",
    style: {
      margin: 0,
      borderColor: 'transparent'
    },
    placeholder: "Type to search...",
    fullWidth: true,
    size: "small",
    inputRef: textRef,
    onBlur: () => setText(textRef.current.value),
    margin: "normal",
    multiline: multiline,
    variant: variant,
    InputLabelProps: {
      shrink: true,
      required
    },
    autcomplete: "off",
    error: textRef && textRef.current && textRef.current.value && !validation.valid,
    helperText: validation.message,
    inputProps: inputProps
  }, rest)));
};
SearchPlaces.propTypes = propTypes;
SearchPlaces.defaultProps = defaultProps;
var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(SearchPlaces);
exports.default = _default;